module.exports = __webpack_public_path__ + "img/app_icon_60-2.c7f635bb.png";